var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description is-flex is-justify-content-center"},[_c('div',[(_vm.illustration)?_c('img',{attrs:{"src":_vm.illustration.path,"alt":_vm.illustration.filename}}):_vm._e(),_c('p',[_vm._v(" "+_vm._s(_vm.content)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }